import type { SaveGoalArgs } from "@components/Chat/InteractiveTool/types";
import { getOnboardingV3Session } from "@/src/hooks/onboarding/onboardingV3SessionStorage";
import { getSaveGoalDraftIdFromStorage } from "@/src/hooks/onboarding/saveGoalDraftIdStorage";

/** confirm-save / activate 共用：显式 goalId → storage → args → onboarding session draftId */
export function resolveGoalIdForActivate(
  args?: Pick<SaveGoalArgs, "goalId">,
  explicitGoalId?: string,
): string | undefined {
  const fromExplicit = explicitGoalId?.trim();
  if (fromExplicit) {
    return fromExplicit;
  }

  const fromStorage = getSaveGoalDraftIdFromStorage()?.trim();
  if (fromStorage) {
    return fromStorage;
  }

  const fromArgs = args?.goalId?.trim();
  if (fromArgs) {
    return fromArgs;
  }

  const fromSession = getOnboardingV3Session()?.planPreview?.draftId?.trim();
  return fromSession || undefined;
}
